<template>
<div class="preview-room" :class="{'active-room': active, 'warn': warn}" @click="selected()">
  <avatar :image="recipient.image" />
  <div class="content">
    <span class="message-sender-text">
      {{ recipient.first_name }} {{ recipient.last_name }}
      <span v-if="missedCount > 0" class="unread-messages">
        {{missedCount}}
        </span>
     </span>
    <div class="message-content" v-if="last_message && last_message.payload">{{compMessage()}}</div>
  </div>
</div>
</template>

<script>
import avatar from "@/components/userImg";
import channelManagement from "@/services/messaging/channelManagement";
import User from "@/services/api/authUser";
import axios from "axios";
export default {
  props: ["room", "active"],
  components: {
    avatar
  },
  data() {
    return {
      warn: false,
      last_message: {},
      missedCount: 0
    };
  },
  created() {
    this.last_message = this.room.last_message;
    let channel = channelManagement.getChannel(this.room.id);
    this.subscription = channel.messages.subscribe(msg => {
      this.last_message = msg;

      if (!this.active && msg.sender_id !== User.id) {
        clearInterval(this.interval);
        this.missedCount += 1;
        this.startInterval();
      }
      this.$forceUpdate();
    });

    axios
      .get(`${process.env.VUE_APP_API_URL}coaches/messaging-rooms/info/`)
      .then(({ data }) => {
        this.missedCount = data[this.room.id] || 0;
        if (this.missedCount > 0) {
          this.startInterval();
        }
      });
  },
  methods: {
    startInterval() {
      this.interval = setInterval(() => (this.warn = !this.warn), 1250);
    },
    selected() {
      this.$emit("selected", this.room);
      this.warn = false;
      this.missedCount = 0;
      clearInterval(this.interval);
    },
    compMessage() {
      let msg = "";
      if (
        this.last_message &&
        this.last_message.payload &&
        this.last_message.payload.message
      ) {
        msg = this.last_message.payload.message;
        if (msg.length > 80) {
          msg =
            msg
              .split(" ")
              .slice(0, 20)
              .join(" ") + "...";
        }
        if (this.last_message.sender.id === User.id) {
          msg = `(You) ${msg}`;
        }
      }
      return msg;
    }
  },
  destroyed() {
    this.subscription.unsubscribe();
    clearInterval(this.interval);
  },
  computed: {
    recipient() {
      return this.room.users.find(user => User.id != user.id);
    }
  }
};
</script>

<style lang="less" scoped>
.preview-room {
  display: flex;
  .content {
    margin-left: 5px;
  }
  .message-sender-text {
    font-weight: 600;
  }
  .message-content {
    opacity: 0.8;
  }
}
.active-room {
  @media (min-width: 630px) {
    background-color: lightgray;
    color: black;
  }
}
.warn {
  .message-sender-text {
    font-weight: 800;
    font-size: 16px;
  }
  // background-color: lightgray;
}
</style>
